import { DeleteFinanceAccountsApi } from "@/features/accounts/finance/services/delete-accounts-api";
import { DeleteFinanceAccountsRequestModel } from "@/features/accounts/finance/services/delete-accounts-model";

/// 銀行口座削除画面処理
export class DeleteFinanceAccountsService {
  private deleteFinanceAccountsApi = new DeleteFinanceAccountsApi();

  /**
   * 銀行口座削除API実行
   */
  public async deleteFinanceAccounts(param: DeleteFinanceAccountsRequestModel) {
    return await this.deleteFinanceAccountsApi.deleteFinanceAccounts(param);
  }
}
